import { render } from "./BlogCbtc.vue?vue&type=template&id=3874c484"
import script from "./BlogCbtc.vue?vue&type=script&lang=js"
export * from "./BlogCbtc.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__